// ProfileCard.js
import React from "react";
import GoogleHotels from "./GoogleHotels";
import Tripadvisor from "./Tripadvisor";
import HolidayCheck from "./HolidayCheck";
import WebSite from "./WebSite";
import DownloadApp from "./DownloadApp";
// import Safe from "./Safe";
import Email from "./Email";
import CartasSpa from "./CartasSpa";
import Bus401 from "./Bus401";
import Bus424 from "./Bus424";
import Bus425 from "./Bus425";
import Market from "./Market";
import Share from "./Share";
import "./ProfileCard.css"; // Importa el archivo CSS

const ProfileCard = () => {
  return (
    <div className="container">
      <div className="card-container">
        <div className="image">
          <img
            src="/images/profile-image.png"
            alt="Logo Iberostar Waves Cala Millor"
          />
        </div>
        <div className="descripcion">
          <h2>QR Share</h2>
          <div className="buttons">
            <GoogleHotels />
            <Tripadvisor />
            <HolidayCheck />
            <div className="group">
              <DownloadApp />
              <WebSite />
            </div>
            <Email />
            <CartasSpa />
            <div className="group">
              <Bus401 />
              <Bus424 />
              <Bus425 />
            </div>
            <Market />
          </div>
          <Share />
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
